const { ProxifiedEntityApi } = require('../common')
const OrganisationPGAdapter = require('./data-access/organisation-pg-adapter')

class OrganisationApi extends ProxifiedEntityApi {
  constructor (state, pgConnection, agaveAdapter, logger) {
    const { user } = state

    const adapter = new OrganisationPGAdapter(logger, pgConnection, user.name)
    super(
      'organisation',
      ['create', 'update', 'list', 'get'],
      !pgConnection,
      adapter,
      agaveAdapter
    )

    this.adapter = adapter
  }

  async getOrganisationIdFromName (name, type = null) {
    const filter = { name }
    if (type) {
      filter.type = type
    }

    const organisations = await this.adapter.getList({ filter })

    if (!organisations.length) {
      throw new Error(`Organisation not found: ${JSON.stringify({ name, type })}`)
    }

    return organisations[0].id
  }
}

module.exports = OrganisationApi
